import {Controller} from 'stimulus';

export default class extends Controller {
  disable(event) {
    setTimeout(() => event.target.disabled = true, 0);
  }
}
